// Console logging utility.
// All logging currently disabled in production, by setting Log.disable true.
// This file must be included in a React package for this disable to work.
// Future: disable/set TZ for time prefix format
// Future: enable capture and recovery of trace history in production.

class Log {
  static logLevel(msg, level) {
    if (Log.disable) {
      return
    }
    const now = new Date()
    const dt = now.toLocaleTimeString('en-US', { hour12: false })
    msg = `${dt}.${now.getMilliseconds()}: ${msg}`
    switch (level) {
      case Log.CRITICAL:
      case Log.EXCEPT:
      case Log.ERROR:
      case Log.ERR:
        // console.exception not standard
        console.error(msg)
        return
      case Log.WARNING:
      case Log.WARN:
        console.warn(msg)
        return
      default:
        // Chrome shows info by default but not debug, so make sure Log.log and Log.debug show.
        // case Log.INFO:
        console.info(msg)
        return
      case Log.DEBUG:
        // console.debug(msg)
        console.info(msg)
        return
      case Log.TRACE:
        // Trace calls are left in the code to assess performance,
        // off in Chrome/production by default (enable Chrome "Verbose").
        // Oddly, they are un-disable in IE devtools!
        console.debug(msg)
    }
  }

  static critical(msg) {
    Log.logLevel(msg, Log.CRITICAL)
  }

  static except(msg) {
    Log.logLevel(msg, Log.EXCEPT)
  }

  static error(msg) {
    Log.logLevel(msg, Log.ERR)
  }

  static err(msg) {
    Log.logLevel(msg, Log.ERR)
  }

  static warning(msg) {
    Log.logLevel(msg, Log.WARNING)
  }

  static warn(msg) {
    Log.logLevel(msg, Log.WARNING)
  }

  static info(msg) {
    Log.logLevel(msg, Log.INFO)
  }

  static log(msg) {
    Log.logLevel(msg, Log.INFO)
  }

  static debug(msg) {
    Log.logLevel(msg, Log.DEBUG)
  }

  static dbg(msg) {
    Log.logLevel(msg, Log.DEBUG)
  }

  static trace(msg) {
    Log.logLevel(msg, Log.TRACE)
  }

  static prettyPrint(pojo) {
    return JSON.stringify(pojo, null, '\t')
  }

  static prettyTrace(pojo) {
    return Log.trace(Log.prettyPrint(pojo))
  }

  static dumpCallStack() {
    if (Log.disable) {
      return
    }
    console.trace()
  }
}

if (process.env.NODE_ENV === 'production') {
  Log.disable = true
}
Log.CRITICAL = 11
Log.EXCEPT = 9
Log.ERROR = 7
Log.ERR = 7
Log.WARNING = 5
Log.WARN = 5
Log.INFO = 3
// Default level for Log.log
Log.DEBUG = 1
// Trace is to mark messages that are key to capturing the context of user actions and event progress through the app.
Log.TRACE = 0
export default Log
